import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CsAgentAuthService } from "@spartacus/asm/root";
import { GlobalMessageService, CmsService, BaseSiteService, GlobalMessageType } from "@spartacus/core";
import { take } from "rxjs/operators";
import { CustomProfileAndPreferencesService } from "src/app/custom-profile-and-preferences/custom-profile-and-preferences.service";
import { MakeAPaymentService } from "src/app/make-a-payment/make-a-payment.service";
import { AddCardService } from "./add-card.service";
import { DataLayerService } from '../../services/data-layer.service';

@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.scss'],
})
export class AddCardComponent implements OnInit {
  url = 'https://angular.io/api/router/RouterLink';
  urlSafe: SafeResourceUrl;
  iframeUrl: any;

  accessTokenForIframe: any;
  defaultCard = false;
  isCheckboxChecked = false;
  sanitizedUrl: any;
  closeResult: any;
  iframeLoad = false;
  dummyUrl: SafeResourceUrl;
  forCheckingAccounts = false;
  submitFlag: boolean;
  submitFlagInitial: boolean=false;
  submitInitialTimeOut: any;
  @ViewChild('iframe') iframe: ElementRef;
  @Input() public isCheckbox;
  @Input() public isCheckout =false; //default value false, else will be true from checkout pages
  pageName: string;
  pageId: string;
  authorizedBy: any;
  isAsmUser: boolean = false;
  csAgentAuthSubscription: any;
  baseSiteId: string;
  constructor(
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly sanitizer: DomSanitizer,
    private readonly csAgentAuthService: CsAgentAuthService,
    public activeModal: NgbActiveModal,
    private readonly globalMessage: GlobalMessageService,
    private readonly addCardService: AddCardService,
    private readonly makeAPaymentService: MakeAPaymentService,
    private readonly pageDate: CmsService,
    private baseSiteService: BaseSiteService,
    private readonly _datalayer: DataLayerService
  ) { }

  ngOnInit(): void {
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    if (this.isCheckbox === false) {
      this.isCheckboxChecked = true;
    }
    this.pageDate.getCurrentPage().subscribe((res) => {
      this.pageName = res?.name;
      this.pageId = res?.pageId;
    })
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
  }

  ngAfterViewInit(): void {
    this.loadScript();
    this.pfService.getIframeUrl(this.forCheckingAccounts);
    this.pfService.iframeUrl.subscribe((data) => {
      this.accessTokenForIframe = data.accessToken;

      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
        data.iframeUrl
      );
      this.dummyUrl = data.iframeUrl;
      this.iframeLoad = true;
    });
  }

  loadScript() {
    if (!window.document.getElementById('payment')) {
      const script = window.document.createElement('script');
      script.id = 'payment';
      script.type = 'text/javascript';
      script.src = './assets/scripts/payments.js';
      window.document.body.appendChild(script);
    }
  }
  onload() {
    window['$XIFrame'].onload({
      iFrameId: 'valid-for-data',
      targetUrl: this.dummyUrl,
      onSuccess: function (e) { },
      onError: function (e) { },
    });
  }
  GetStats(event) {
    this.defaultCard = event.currentTarget.checked;
    if (this.defaultCard) {
      this.isCheckboxChecked = true;
    }
  }
  saveCard(event) {
    this.isCheckboxChecked = event.currentTarget.checked;
  }

  onSubmitIFrame() {
    let cardOrAcc = this.forCheckingAccounts ? 'account' : 'card';
    let errorMessage = '';
    // this.submitFlag = true; //with this, button disables if no details entered and button clicked
    clearTimeout(this.submitInitialTimeOut);
    this.submitFlagInitial = true;
    window['$XIFrame'].submit({
      iFrameId: 'valid-for-data',
      targetUrl: this.dummyUrl,
      autosizeheight: true,
      autosizewidth: true,

      onSuccess: (msg) => {
        const message = JSON.parse(msg);
        // this.activeModal.close();
        this.submitFlag = true;
        if (message && message.data.HasPassed) {
          //this.submitFlag = true;
          let params
          if (!this.isAsmUser) {
            params = {
              accessToken: this.accessTokenForIframe,
              defaultPaymentInfo: this.defaultCard,
              savePaymentDetails: this.isCheckboxChecked,
              ach: this.forCheckingAccounts
            }
          } else {
            params = {
              accessToken: this.accessTokenForIframe,
              authorizedBy: this.authorizedBy,
              defaultPaymentInfo: this.defaultCard,
              savePaymentDetails: this.isCheckboxChecked,
              ach: this.forCheckingAccounts
            }
          }
          this.addCardService
            .addCard(params,this.isCheckout)
            .subscribe((res) => 
              {
              this.activeModal.close();
              this.submitFlag = false;
              if (res && res?.addPaymentDetails === true) {
                this.pfService.getAccountIdFromDb();
                this.addCardService.cardAdded.next(res);
                this._datalayer.addtoDataLayer('addCard_FormEvent', cardOrAcc, '', '', 'form_submit', '');
                // if (this.pageId === 'MyAccountOpenInvoicePaymentPage') {
                //   window.location.reload();
                // } else {
                //   this.activeModal.close();
                // }
                // this.activeModal.close();
              } else {
                window.scrollTo(0, 0);
                if (res?.errorMessage === 'E') {
                  this._datalayer.addtoDataLayer('addCard_FormEvent', cardOrAcc, '', '', 'form_error', '');
                  errorMessage = `This ${cardOrAcc} already exists in BP. Please try with another ${cardOrAcc}.`;
                  this.globalMessage.add(errorMessage,
                    GlobalMessageType.MSG_TYPE_ERROR, 5000
                  );
                } else {
                  //using below obs only in make a payment
                  if (this.pageId === 'MyAccountOpenInvoicePaymentPage') {
                    this.addCardService.cardCloseError.next(true);
                  }
                  if(this.baseSiteId == 'vsh') {
                    errorMessage = `The ${cardOrAcc} could not be added. Please check the provided information and try again. For assistance, please contact customer service at 1-800-VACCINE (1-800-822-2463).`;
                  } else {
                    errorMessage = `The ${cardOrAcc} could not be added. Please check the provided information and try again. For assistance, please contact customer service at 1-800-752-9338.`;
                  }
                  this._datalayer.addtoDataLayer('addCard_FormEvent', cardOrAcc, '', '', 'form_error', '');
                  this.globalMessage.add(errorMessage,
                    GlobalMessageType.MSG_TYPE_ERROR, 5000
                  );
                }
              }
              }, 
              (errors) => {
              this.activeModal.close();
              window.scrollTo(0, 0);
              this.submitFlag = false;
              this.addCardService.cardCloseError.next(true);
              if(this.baseSiteId == 'vsh') {
                errorMessage = `The ${cardOrAcc} could not be added. Please check the provided information and try again. For assistance, please contact customer service as 1-800-VACCINE (1-800-822-2463).`;
              } else {
                errorMessage = `The ${cardOrAcc} could not be added. Please check the provided information and try again. For assistance, please contact customer service as (1-800-752-9338).`;
              }  
              this.globalMessage.add(errorMessage,
                  GlobalMessageType.MSG_TYPE_ERROR, 5000);
            });
        }
        else{
          this.submitFlag = false;
        }
      },
      onError: function (msg) {
        this.submitFlag = false;
        this.activeModal.close();
        window.scrollTo(0, 0);
        this._datalayer.addtoDataLayer('addCard_FormEvent', cardOrAcc, '', '', 'form_error', '');
        if(this.baseSiteId == 'vsh') {
          errorMessage = `The ${cardOrAcc} could not be added. Please check the provided information and try again. For assistance, please contact customer service as 1-800-VACCINE (1-800-822-2463).`;
        } else {
          errorMessage = `The ${cardOrAcc} could not be added. Please check the provided information and try again. For assistance, please contact customer service as (1-800-752-9338).`;
        }
        this.globalMessage.add(errorMessage,
            GlobalMessageType.MSG_TYPE_ERROR, 5000);
      },
    });
    this.submitInitialTimeOut=setTimeout(() => {
      this.submitFlagInitial=false;
    },2000);
  }

  ngOnDestroy() {
    // this.addCardService.cardAdded.next(false);
    this.csAgentAuthSubscription?.unsubscribe();
  }

  closeIframe(){
    if (this.pageId === 'MyAccountOpenInvoicePaymentPage') {
      this.addCardService.cardCloseError.next(true);
    }
  }
}